

<template>
    <div style="margin-top:15px;">
        <h3 style="cursor: pointer; user-select: none;" @click="showAuditHistory =! showAuditHistory">Audit History <span v-if="!showAuditHistory">+</span><span v-if="showAuditHistory">-</span></h3>
        <div v-if="showAuditHistory" class="history">
            <div stlye="outline-style: dotted;" v-for="s in snapShots" :key="s.id">

                <div class="row" style="font-weight:bold;">
                    <div class="col-md-4">Created Date</div>
                    <div class="col-md-4">By</div>
                    <div class="col-md-4">Status</div>
                </div>


                <div class="row" style="margin-bottom:15px;">
                    <div class="col-md-4">{{s.createdDate | formatDate}}</div>
                    <div class="col-md-4"> {{s.createdBy}}</div>
                    <div class="col-md-4">{{s.currentExpenseReportStatusName}}</div>
                </div>


                <!-- Trip Profile -->
                <div v-if="(area == 'trip' || area == 'all') && s.tripSnapshot.hasChanges" style="margin-bottom:25px;">
                    <h5>Trip Profile Changes</h5>
                    <div class="row">
                        <div class="col-md-4">Field</div>
                        <div class="col-md-4">Old Value</div>
                        <div class="col-md-4">New Value</div>
                    </div>
                    <hr class="style-three" />

                    <SnapShotComponent v-for="sSD in s.tripSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>

                    <div v-for="d in s.tripSnapshot.destinations">



                        <!--<div class="key-style">Destination ID {{d.id}} Changes</div>-->


                        <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2" :parentItemName="'DestinationID_' + d.id + '.'"></SnapShotComponent>
                        <SnapShotComponent v-for="sSD2 in d.personalDates" :snapshot="sSD2" :parentItemName="'DestinationID_' + d.id + '.'"></SnapShotComponent>

                    </div>
                </div>
                <!-- Trip Profile End -->
                <!-- AIRFARE -->
                <div v-if="(area == 'air' || area == 'all') && s.airfareSnapshot.hasChanges" style="margin-bottom:25px;">
                    <h5>Airfare Changes</h5>
                    <div class="row">
                        <div class="col-md-4">Field</div>
                        <div class="col-md-4">Old Value</div>
                        <div class="col-md-4">New Value</div>
                    </div>
                    <hr class="style-three" />

                    <SnapShotComponent v-for="sSD in s.airfareSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>

                    <div v-for="d in s.airfareSnapshot.airfareBaggages">
                        <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2" :parentItemName="'BaggageID_' + d.id + '.'"></SnapShotComponent>
                    </div>

                    <div v-for="d in s.airfareSnapshot.airfareTickets">
                        <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2" :parentItemName="'TicketID_' + d.id + '.'"></SnapShotComponent>
                    </div>
                </div>
                <!-- AIRFARE End-->
                <!-- lodging -->
                <div v-if="(area == 'lodging' || area == 'all') && s.lodgingSnapshot.hasChanges" style="margin-bottom:25px;">
                    <h5>Lodging Changes</h5>
                    <div class="row">
                        <div class="col-md-4">Field</div>
                        <div class="col-md-4">Old Value</div>
                        <div class="col-md-4">New Value</div>
                    </div>
                    <hr class="style-three" />

                    <SnapShotComponent v-for="sSD in s.lodgingSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>

                    <div v-for="d in s.lodgingSnapshot.lodges">
                        <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2" :parentItemName="d.friendlyDisplayId + ' '"></SnapShotComponent>
                        <div v-for="e in d.lodgeDates">
                            <SnapShotComponent v-for="sSD3 in e.snapshotDetails" :snapshot="sSD3" :parentItemName="d.friendlyDisplayId + ' ' + e.friendlyDisplayId + ' '"></SnapShotComponent>
                            <div v-for="f in e.exceptions">
                                <SnapShotComponent v-for="sSD5 in f.snapshotDetails" :snapshot="sSD5" :parentItemName="d.friendlyDisplayId + ' ' + e.friendlyDisplayId + ' ' + 'EID_'+ f.id"></SnapShotComponent>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- lodging end -->
                <!-- meals -->
                <div v-if="(area == 'meals' || area == 'all') && s.mealsSnapshot.hasChanges" style="margin-bottom:25px;">
                    <h5>Meals Changes</h5>
                    <div class="row">
                        <div class="col-md-4">Field</div>
                        <div class="col-md-4">Old Value</div>
                        <div class="col-md-4">New Value</div>
                    </div>
                    <hr class="style-three" />

                    <SnapShotComponent v-for="sSD in s.mealsSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>
                    <div v-for="(d, dIndex) in s.mealsSnapshot.mealDates">
                        <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2" :parentItemName="d.friendlyDisplayId + ' '"></SnapShotComponent>
                        <div v-for="e in d.meals">
                            <SnapShotComponent v-for="sSD3 in e.snapshotDetails" :snapshot="sSD3" :parentItemName="d.friendlyDisplayId + ' ' + e.friendlyDisplayId + ' '"></SnapShotComponent>
                            <div v-for="f in e.exceptions">
                                <SnapShotComponent v-for="sSD5 in f.snapshotDetails" :snapshot="sSD5" :parentItemName="d.friendlyDisplayId + ' ' + e.friendlyDisplayId + ' ' + 'EID_'+ f.id"></SnapShotComponent>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- meals end -->
                <!-- rental -->
                <div v-if="(area == 'rental' || area == 'all') && s.carRentalSnapshot.hasChanges" style="margin-bottom:25px;">
                    <h5>Rental Car Changes</h5>
                    <div class="row">
                        <div class="col-md-4">Field</div>
                        <div class="col-md-4">Old Value</div>
                        <div class="col-md-4">New Value</div>
                    </div>
                    <hr class="style-three" />

                    <SnapShotComponent v-for="sSD in s.carRentalSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>

                    <div v-for="d in s.carRentalSnapshot.fuelCosts">
                        <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2" :parentItemName="'FuelID_' + d.id + '.'"></SnapShotComponent>
                    </div>

                    <div v-for="d in s.carRentalSnapshot.rentalCars">
                        <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2" :parentItemName="'RentalID_' + d.id + '.'"></SnapShotComponent>
                    </div>
                </div>
                <!-- rental end -->
                <!-- other -->
                <div v-if="(area == 'other' || area == 'all')  && (s.transportationSnapshot.hasChanges || s.expenseReportMiscSnapshot.hasChanges)" style="margin-bottom:25px;">
                    <h5>Other Changes</h5>
                    <div class="row">
                        <div class="col-md-4">Field</div>
                        <div class="col-md-4">Old Value</div>
                        <div class="col-md-4">New Value</div>
                    </div>
                    <hr class="style-three" />

                    <SnapShotComponent v-for="sSD in s.transportationSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>

                    <div v-for="d in s.transportationSnapshot.groundTransportations">
                        <SnapShotComponent v-for="sSD in d.snapshotDetails" :snapshot="sSD" :parentItemName="'GroundTranID_' + d.id + '.'"></SnapShotComponent>
                    </div>

                    <div v-for="d in s.transportationSnapshot.personalVehicleMileages">
                        <SnapShotComponent v-for="sSD in d.snapshotDetails" :snapshot="sSD" :parentItemName="'PVMID_' + d.id + '.'"></SnapShotComponent>
                    </div>

                    <SnapShotComponent v-for="sSD in s.expenseReportMiscSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>

                    <div v-for="d in s.expenseReportMiscSnapshot.miscCosts">
                        <SnapShotComponent v-for="sSD in d.snapshotDetails" :snapshot="sSD" :parentItemName="'MiscCostID_' + d.id + '.'"></SnapShotComponent>
                    </div>
                </div>
                <!-- other end -->
                <!-- review -->
                <div v-if="(area == 'review' || area == 'all') && s.expenseReportSubmissionSnapshot.hasChanges" style="margin-bottom:75px;">
                    <h5>Review Changes</h5>
                    <div class="row">
                        <div class="col-md-4">Field</div>
                        <div class="col-md-4">Old Value</div>
                        <div class="col-md-4">New Value</div>
                    </div>
                    <hr class="style-three" />
                    <SnapShotComponent v-for="sSD in s.expenseReportSubmissionSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>
                    <div v-for="p in s.expenseReportSubmissionSnapshot.projectAmountAllocations">
                        <SnapShotComponent v-for="pSSD in p.snapshotDetails" :snapshot="pSSD" :parentItemName="'ER_ProjectAmountAllocation' + p.id + '.'"></SnapShotComponent>
                    </div>
                </div>
                <!-- review end -->
                <!-- misc expense report -->
                <div v-if="area == 'misc' && s.miscReportSnapshotModel.hasChanges" style="margin-bottom:75px;">
                    <h5>Review Changes</h5>
                    <div class="row">
                        <div class="col-md-4">Field</div>
                        <div class="col-md-4">Old Value</div>
                        <div class="col-md-4">New Value</div>
                    </div>
                    <hr class="style-three" />
                    <div v-for="d in s.miscReportSnapshotModel.miscReportItems">
                        <SnapShotComponent v-for="sSD in d.snapshotDetails" :snapshot="sSD" :parentItemName="'MER_' + d.id + '.'"></SnapShotComponent>
                        <div v-for="a in d.attachments">
                            <SnapShotComponent v-for="aSSD in a.snapshotDetails" :snapshot="aSSD" :parentItemName="'MER_Attachments' + d.id + '.'"></SnapShotComponent>
                        </div>
                        <div v-for="p in d.projectAmountAllocations">
                            <SnapShotComponent v-for="pSSD in p.snapshotDetails" :snapshot="pSSD" :parentItemName="'MER_ProjectAmountAllocation' + p.id + '.'"></SnapShotComponent>
                        </div>
                    </div>
                </div>
                <!-- misc expense report end-->
            </div>
        </div>
    </div>
</template>

<style scoped>
    .history {
        max-height: 400px;
        overflow-x: hidden;
    }

    h5 {
        margin-bottom: 5px;
    }

    hr.style-three {
        border: 0;
        border-bottom: 1px dashed #ccc;
        background: #999;
        margin-bottom: 5px;
        margin-top: 0px;
    }
</style>

<script type="text/babel">
    import SnapShotComponent from '@/components/SnapShotComponent.vue'
    import SnapShotService from '@/services/SnapShotService'

    export default {
    components: {
    SnapShotComponent
    },

    async created() {
    this.snapShots = await SnapShotService.getAllSnapshots(this.expenseReportID);
    },

    props: {
    "expenseReportID": {default: null},
    "area":{default:null}
    },

    data: function () {
    return { snapShots: null,
    showAuditHistory:false}
    }
    }
</script>